<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title" >Review Management / View</h1>
        </div>
        <div class="content-section">
            <div class="order-view max-WT setting-page">
                <div class="mb40">
                    <div class="add-store-block input-style mb20 ">
                        <form>
                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12 d-flex">
                                    <label class="col-md-5"> 
                                      <h6>Reviewed By :</h6>    
                                    </label>
                                    <p  class="col-md-7"> {{reviewData?.givenBy?.firstName}} {{reviewData?.givenBy?.lastName}} </p>
                                </div>
                            </div>
                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12 d-flex">
                                    <label class="col-md-5">
                                        <h6>Reviewed To :</h6>    

                                    </label>
                                    <p class="col-md-7"> {{reviewData?.givenTo?.firstName || '--'}} {{reviewData?.givenTo?.lastName}}  </p>
                                </div>
                            </div>

                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12 d-flex">
                                    <label class="col-md-5">
                                        <h6>Feedback : </h6>
                                    </label>
                                    <p class="col-md-7"> {{reviewData?.feedback}} </p>
                                </div>
                            </div>
                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12 d-flex">
                                    <label class="col-md-5">
                                    <h6>Rating :</h6>    
                                    </label>
                                    <p class="col-md-7"> {{reviewData?.rating}} </p>
                                </div>
                            </div>
                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12 d-flex">
                                    <label class="col-md-5">
                                    <h6>Date :</h6>    
                                    </label>
                                    <p class="col-md-7"> {{reviewData?.createdAt | date : 'd/M/y' :'UTC'}} </p>
                                </div>
                            </div>

                            <div class="text-center mt-5">
                                <button class="btn btn-theme" routerLink="/review-mgt">Back</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>